import './ccf-call-hung-up-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfCallHungUpIconProps extends SvgIconProps {}

/**
 * Component displays call hung up  svg icon 
 * @param props -CcfCallHungUpIconProps
 * @returns hung up svg icon
 * @example - <CcfCallHungUpIcon/>
 */
export function CcfCallHungUpIcon(props: CcfCallHungUpIconProps) {
  return (
    <SvgIcon {...props}>
     <g id="Hang_Up" data-name="Hang Up">
    <rect width="20" height="20" fill="none"/>
    <g id="Group_118187" data-name="Group 118187" transform="translate(-574 -207)">
      <g id="Rectangle_80258" data-name="Rectangle 80258" transform="translate(574 207)" fill="#526b7a" stroke="#707070" strokeWidth="1" opacity="0">
        <rect width="19.999" height="19.999" stroke="none"/>
        <rect x="0.5" y="0.5" width="18.999" height="18.999" fill="none"/>
      </g>
      <path id="Path_12738" data-name="Path 12738" d="M-21.236-154.175c-.025-.122-.118-.281-.684-.684a10.866,10.866,0,0,0-4.1-2.051,19.116,19.116,0,0,0-4.786-.684,22.98,22.98,0,0,0-5.469.684,10.867,10.867,0,0,0-4.1,2.051c-.565.4-.659.561-.684.684a11.148,11.148,0,0,0,0,2.735c.069.545.153.436,1.367.684,1.645.335,3.643.177,3.418-.684,0,0,.021-1.251,0-1.367s-.617-1.024,0-1.367c.678-.377,2.647-.683,5.469-.684s4.108.307,4.786.684c.617.343.021,1.251,0,1.367s0,1.367,0,1.367c-.224.861,1.774,1.019,3.418.684,1.214-.247,1.3-.139,1.367-.684A11.143,11.143,0,0,0-21.236-154.175Z" transform="translate(615.148 371.093)"/>
    </g>
  </g>
    </SvgIcon>
  );
}

export default CcfCallHungUpIcon;
